// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","circle":"Tag_circle__crhGJ","primary":"Tag_primary__htqqW","success":"Tag_success__HBwyK","error":"Tag_error__gZaFj"};